import useModal from 'hooks/useModal';
import { useMutation } from 'react-query';
import { postPositionWithWord } from 'utils/postPosition';
import { isTCustomAxiosError } from 'apis/config/axios';
import { deletePracticeChart } from 'apis/chart/studentPracticeChart';
import { deleteEvaluationChart } from 'apis/chart/studentEvaluationChart';
import useGoBack from 'hooks/useGoBack';

type TProps = {
  category: string;
  id: number;
  chartName: string | undefined;
  patientId?: string | undefined;
  courseInfoId?: string | undefined;
  chartRound?: string | undefined;
};

const useDeleteChart = () => {
  const { openModal } = useModal();
  const goBack = useGoBack();

  const { mutate: deleteChartMutation } = useMutation(
    async ({ category, id }: TProps) => {
      switch (category) {
        case 'practice': {
          const response = await deletePracticeChart(id);
          return response;
        }
        case 'evaluation': {
          const response = await deleteEvaluationChart(id);
          return response;
        }
        default:
          return Promise.reject();
      }
    },
    {
      onSuccess: (_, context) => {
        const { category, patientId, courseInfoId, chartRound } = context;
        goBack(
          category !== 'practice'
            ? {
                patientId,
                courseInfoId,
                chartRound,
              }
            : {}
        );
      },
      onError: (error) =>
        openModal({
          title: '차트 삭제 실패',
          text: isTCustomAxiosError(error)
            ? error.data?.toString() || error.message
            : '다시 시도해 주세요.',
        }),
    }
  );

  const deleteChart = ({
    category,
    id,
    chartName,
    patientId,
    courseInfoId,
    chartRound,
  }: TProps) =>
    openModal({
      isConfirm: true,
      title: '해당 차트를 삭제하시겠습니까?',
      text: `삭제한 차트는 복구할 수 없습니다.\n 정말 ${postPositionWithWord({
        format: ['을', '를'],
        word: chartName || '',
      })} 삭제하시겠습니까?`,
      onSubmit: () =>
        deleteChartMutation({
          category,
          id,
          chartName,
          patientId,
          courseInfoId,
          chartRound,
        }),
    });

  return { deleteChart };
};

export default useDeleteChart;
